import { useRef, useState } from "react";
import { Avatar } from "./GmbManager";
import domain from "../reusecomponent/domain";
import { useSelector } from "react-redux";
import { ErrorToastContainer, SuccessToastContainer } from "../whatsapp/function/CustomFunction";
import Loader from "../CommerceManager/component/Loader";

export const ReviewCard = ({ id,review, reply,Store_code }) => {
  const starCount = ratingMap[review.starRating] || 0;

  const parsedReplyRef = useRef(reply ?? null);

  const [isReplying, setIsReplying] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [replyText, setReplyText] = useState(reply?.comment || "");
  const [loading,setLoading] = useState(false);
  const Accesstoken = useSelector((state) => state.Token.value);

  const handleSaveReply = async () => {
    if (!replyText.trim()) return;
    try {
      setLoading(true);
      const formdata = new FormData();
      formdata.append("comment",replyText.trim());
      const res = await fetch(`${domain()}/gmb/review/reply/${btoa(Store_code)}/${btoa(id)}`, {
        headers: { Authorization: `Bearer ${Accesstoken}` },
        body:  formdata,
        method: "POST"
      });
      const json = await res.json();
      if (res.ok && json.status){
        parsedReplyRef.current = JSON.parse(json.data);
        console.log(parsedReplyRef.current.comment);
        SuccessToastContainer(json.message);
        setIsReplying(false);
        setIsEditing(false);
      }else{
        ErrorToastContainer(json.message);
      }
    } catch (e){
      ErrorToastContainer("Internal Server Problem");
    } finally {
      setLoading(false);
    }

  };


  const handleDeleteReply = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${domain()}/gmb/review/reply/${btoa(Store_code)}/${btoa(id)}`, {
        headers: { Authorization: `Bearer ${Accesstoken}` },
        method: "DELETE"
      });
      const json = await res.json();
      if (res.ok && json.status){
        parsedReplyRef.current = null;
        SuccessToastContainer(json.message);
        setReplyText("");
        setIsEditing(false);
      }else{
        ErrorToastContainer(json.message);
      }
    } catch {
      ErrorToastContainer("Internal Server Problem");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="border-bottom py-3 px-3">
      {loading && (
        <Loader/>
      )}
      {/* ================= REVIEW HEADER ================= */}
      <div className="d-flex justify-content-between align-items-start">
        <div className="d-flex gap-3">
          <Avatar
            title={review.reviewer?.displayName}
            image={review.reviewer?.profilePhotoUrl}
          />

          <div>
            <div className="fw-semibold">
              {review.reviewer?.displayName}
            </div>

            <div className="d-flex align-items-center gap-2 text-muted small">
              <div>
                {Array.from({ length: starCount }).map((_, i) => (
                  <span key={i} style={{ color: "#fbbc04" }}>★</span>
                ))}
              </div>
              <span>•</span>
              <span>{timeAgo(review.createTime)}</span>
            </div>
          </div>
        </div>

        <div style={{ cursor: "pointer" }}>⋮</div>
      </div>

      {/* ================= REVIEW COMMENT ================= */}
      <div className="mt-2" style={{ maxWidth: "600px" }}>
        {review.comment}
      </div>

      {/* ================= OWNER REPLY ================= */}
      {parsedReplyRef.current && !isEditing && (
        <div className="mt-3 d-flex gap-3">
          <Avatar title="Owner" image={null} />

          <div>
            <div className="fw-semibold">(owner)</div>
            <div className="text-muted small mb-1">
              {timeAgo(parsedReplyRef.current.updateTime)}
            </div>
            <div>{parsedReplyRef.current.comment}</div>

            <div className="d-flex gap-3 mt-2">
              <button
                className="btn btn-link p-0"
                onClick={() => setIsEditing(true)}
              >
                Edit
              </button>
              <button
                className="btn btn-link text-danger p-0"
                onClick={handleDeleteReply}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ================= REPLY INPUT (NEW / EDIT) ================= */}
      {(!parsedReplyRef.current || isEditing) && (
        <>
          {!parsedReplyRef.current && !isReplying && (
            <button
              className="btn btn-link p-0 mt-2"
              onClick={() => setIsReplying(true)}
            >
              Reply
            </button>
          )}

          {(isReplying || isEditing) && (
            <div className="mt-3 d-flex gap-3">
              <Avatar title="Owner" image={null} />

              <div className="flex-grow-1">
                <div className="fw-semibold mb-1">(owner)</div>

                <textarea
                  className="form-control border-0 border-bottom rounded-0"
                  rows="2"
                  placeholder="Your reply"
                  value={replyText}
                  onChange={(e) => setReplyText(e.target.value)}
                  style={{ resize: "none" }}
                />

                <div className="d-flex gap-3 mt-2">
                  <button
                    className="btn btn-primary btn-sm"
                    disabled={!replyText.trim()}
                    onClick={handleSaveReply}
                  >
                    {isEditing ? "Update reply" : "Post reply"}
                  </button>

                  <button
                    className="btn btn-link btn-sm text-muted"
                    onClick={() => {
                      setIsReplying(false);
                      setIsEditing(false);
                      setReplyText(parsedReplyRef.current?.comment || "");
                    }}
                  >
                    Cancel
                  </button>
                </div>

                <small className="text-muted d-block mt-2">
                  Your reply will be displayed publicly on Google.
                </small>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};


const timeAgo = (date) => {
  const diff = Math.floor((Date.now() - new Date(date)) / 1000);
  const days = Math.floor(diff / 86400);
  if (days > 7) return `${Math.floor(days / 7)} week ago`;
  if (days > 0) return `${days} day ago`;
  const hours = Math.floor(diff / 3600);
  if (hours > 0) return `${hours} hour ago`;
  const minutes = Math.floor(diff / 60);
  return `${minutes} min ago`;
};

const ratingMap = {
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  FIVE: 5,
};